module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/id/2/5-6599eaddd9db34f09c002bc852b61bd6.jpg";